module.exports = __webpack_public_path__ + "4ee869557ea610cc0466a2777819ad3a.svg";